import Commons from '../helpers/Commons';

export const suggestionLabel = {
    address: 'address',
    state: 'state',
    street: 'street',
    postcode: 'postcode',
    councilArea: 'council area',
    locality: 'suburb',
    territorialAuthority: 'territorial authority',
    suburb: 'suburb',
};

export const SUGGESTION_CONTEXT = {
    ...Object
        .fromEntries(Object
            .entries(suggestionLabel)
            .map(([key, value]) => [key, Commons.capitalizeFirstLetter(value)])),
    address: 'Property',
};

export default {
    ADDRESS: 'address',
    STATE: 'state',
    STREET: 'street',
    POSTCODE: 'postcode',
    COUNCIL_AREA: 'councilArea',
    LOCALITY: 'locality',
    SCHOOL: 'school',
    TERRITORIAL_AUTHORITY: 'territorialAuthority',
    SUBURB: 'suburb',
    PARCEL: 'parcel',
    LEGAL_DESC: 'legalDesc',
    TITLE_REF: 'titleRef',
};
